import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDeleteDisabledIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_1259_3394",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 16,
		height: 16,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_1259_3394)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M4.16667 14C3.76944 14 3.4294 13.8586 3.14653 13.5757C2.86366 13.2928 2.72222 12.9528 2.72222 12.5556V3.16667H2V1.72222H5.61111V1H9.94445V1.72222H13.5556V3.16667H12.8333V12.5556C12.8333 12.9528 12.6919 13.2928 12.409 13.5757C12.1262 13.8586 11.7861 14 11.3889 14H4.16667ZM11.3889 3.16667H4.16667V12.5556H11.3889V3.16667ZM5.61111 11.1111H7.05556V4.61111H5.61111V11.1111ZM8.5 11.1111H9.94445V4.61111H8.5V11.1111Z",
			fill: "#C2C6D4"
		})
	})]
});
export default SvgDeleteDisabledIcon;
